import { ReadonlySignal } from '@preact/signals-react';

import { OperationResult } from '@vp/common/core/OperationResult';
import { LoadProfileDto } from '@vp/profile/core/dto/LoadProfileDto';
import { ProfileLoadingState } from '@vp/profile/core/interface/ProfileState';
import { ProfileModel } from '@vp/profile/core/model/ProfileModel';

export abstract class ProfilePort {
  abstract readonly profile: ReadonlySignal<ProfileModel>;
  abstract readonly loadingState: ReadonlySignal<ProfileLoadingState>;
  abstract readonly canActivateProfile: ReadonlySignal<boolean>;
  abstract readonly profileForActivation: ReadonlySignal<string | null>;

  abstract scheduleSlideshow(): Promise<void>;
  abstract loadProfile(dto: LoadProfileDto): Promise<void>;
  abstract activateProfile(id: string, controller?: AbortController): Promise<OperationResult>;
  abstract storeProfileForActivation(id: string): void;
  abstract resetProfileForActivation(): void;
  abstract unlockProfile(id: string, code: string, controller?: AbortController): Promise<OperationResult<ProfileModel>>;
  abstract setProfile(profile: ProfileModel): Promise<void>;
}
